import { render, staticRenderFns } from "./EditTemplate.vue?vue&type=template&id=56058054&"
import script from "./EditTemplate.vue?vue&type=script&lang=js&"
export * from "./EditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports